import React from 'react';
import { styled } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
// Material UI icons
import CloseIcon from '@mui/icons-material/Close';
// React components
import ContactUsContent from 'views/common/components/Logical/Layout/Footer/NeedHelp/ContactUsContent';

const PREFIX = 'ContactUsDialog';

const classes = {
  paper: `${PREFIX}-paper`,
  dividers: `${PREFIX}-dividers`,
  dialogContent: `${PREFIX}-dialogContent`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '90%',
    maxHeight: '90vh',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxHeight: '100vh',
      height: '100%',
      margin: 0,
      borderRadius: 0,
    },
    backgroundColor: theme.palette.background.default,
    color: theme.palette.secondary.main,
  },
  '& .MuiDialogTitle-root': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [`& .${classes.dividers}`]: {
    borderTop: `1px solid ${theme.palette.grey['50']}`,
    padding: theme.spacing(2, 1.5),
  },

  [`& .${classes.dialogContent}`]: {
    padding: [0, '!important'],
  },
}));

const SlideTransition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ContactUsDialog = (props) => {
  const {
    onClose, open, title, userId, leadCategoryId, ...other
  } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <StyledDialog
      id="contact-us-dialog"
      TransitionComponent={SlideTransition}
      aria-labelledby="countries-dialog"
      open={open}
      classes={{
        paper: classes.paper,
      }}
      maxWidth="xl"
      keepMounted
      onClose={handleClose}
      {...other}>
      <DialogTitle>
        <Typography variant="h3">{title}</Typography>
        <IconButton
          onClick={handleClose}
          aria-label="Cancel"
          color="secondary"
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className={classes.dialogContent}
        classes={{
          dividers: classes.dividers,
        }}>
        <ContactUsContent
          userId={userId}
          leadCategoryId={leadCategoryId}
          onClose={handleClose}
        />
      </DialogContent>
    </StyledDialog>
  );
};

export default ContactUsDialog;
